export const handleSubmit = ({ createContract, history, currentCustomerId }) => values => {

  if (!!values.tiiviiOttConfig && !values.tiiviiOttConfig.enabled) {
    values.tiiviiOttConfig.webhookUrl = '';
    values.tiiviiOttConfig.nimbleConfigUrl = '';
  }

  const updatedData = createContract({
    variables: {
      contractInput: values,
      customerId: currentCustomerId,
    },
  });

  return updatedData.then(result => {
    const contract = result.data.createContract;
    if (contract && contract.id) {
      history.replace(`/contract/details/${contract.id}`);
    }
  });
};